var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.06 21.95-1.71-1.69c-.42-.42-1-.65-1.59-.65H6c-2.07 0-3.75-1.67-3.75-3.72V4.98c0-2.05 1.68-3.72 3.75-3.72h12c2.07 0 3.75 1.67 3.75 3.72v10.91c0 2.05-1.68 3.72-3.75 3.72h-.76a2.3 2.3 0 0 0-1.59.65l-1.71 1.69a2.75 2.75 0 0 1-3.88 0zM3.75 4.97v10.91c0 1.23 1.01 2.22 2.25 2.22h.76c.99 0 1.95.4 2.65 1.09l1.71 1.69c.49.48 1.28.48 1.77 0l1.71-1.69c.7-.69 1.66-1.09 2.65-1.09H18c1.24 0 2.25-1 2.25-2.22V4.97c0-1.23-1.01-2.22-2.25-2.22H6c-1.24 0-2.25 1-2.25 2.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.48 15.67c-1.32-.45-4.72-2.44-4.72-6.16 0-1.8 1.46-3.26 3.25-3.26.73 0 1.43.25 2 .69.57-.44 1.27-.69 2-.69 1.79 0 3.25 1.46 3.25 3.26 0 3.72-3.41 5.71-4.72 6.16a1.768 1.768 0 0 1-1.06 0zM8.25 9.51c0 2.83 2.75 4.41 3.71 4.74h.08c.97-.34 3.7-1.92 3.7-4.73 0-.97-.78-1.76-1.75-1.76-.55 0-1.06.26-1.4.7-.28.38-.92.38-1.2 0-.32-.45-.83-.71-1.39-.71-.96 0-1.75.79-1.75 1.76z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineLike);
export default __webpack_public_path__ + "static/media/vuesax-outline-like.c21176d9733100ad3033ccc8a4514243.svg";
export { ForwardRef as ReactComponent };